import React from 'react';

const About = () => {
  const partnerships = [
    "Exclusive Agent-Distributor Agreements with leading international manufacturers",
    "Global System Providers collaborations",
    "International Engineering Firms alliances"
  ];

  const whyChoose = [
    "Comprehensive Solutions - End-to-end services from consultation to ongoing support",
    "Technological Leadership - Continuous investment in research and development",
    "Unwavering Quality Commitment - Adherence to highest international standards",
    "Expert Team - Highly qualified professionals with extensive experience",
    "Customer-Centric Approach - Collaborative and transparent process"
  ];

  return (
    <div className="about-page">
      <section className="page-header">
        <div className="container">
          <h1>About TAQNYA FZCO</h1>
          <p>Leading provider of electromechanical systems and smart solutions</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Company Overview</h2>
          <div className="company-overview" style={{ maxWidth: '900px', margin: '0 auto' }}>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '30px' }}>
              TAQNYA FZCO is a leading provider of electromechanical systems and smart solutions based in the United Arab Emirates. 
              With a steadfast commitment to innovation, reliability, and efficiency, we empower our clients with cutting-edge 
              solutions that enhance safety, convenience, and sustainability.
            </p>
            
            <div className="mission-vision" style={{ margin: '40px 0' }}>
              <div className="mission">
                <h3>Our Mission</h3>
                <p>To deliver innovative, reliable, and efficient electromechanical solutions that enhance safety, convenience, and sustainability for our clients.</p>
              </div>
              <div className="vision">
                <h3>Our Vision</h3>
                <p>To be the preferred partner in smart electromechanical solutions across the region, distinguished by our excellence in technological innovation and service delivery.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: '#f7fafc' }}>
        <div className="container">
          <h2 className="section-title">Why Choose TAQNYA FZCO</h2>
          <div className="services-grid">
            {whyChoose.map((item, index) => (
              <div className="service-card" key={index}>
                <h3>{item.split(' - ')[0]}</h3>
                <p>{item.split(' - ')[1]}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Global Partnerships</h2>
          <div className="services-list">
            <div className="service-item">
              <h3>Strategic International Alliances</h3>
              <p>TAQNYA FZCO prides itself on its robust network of global partnerships, providing unparalleled access to cutting-edge technologies, competitive pricing, and guaranteed authenticity for all components.</p>
              
              <ul>
                {partnerships.map((partnership, index) => (
                  <li key={index}>{partnership}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;